// utils.js
if (!Array.prototype.findLastIndex) {
	Array.prototype.findLastIndex = function(callback, thisArg) {
		if (this == null) {
			throw new TypeError('Array.prototype.findLastIndex called on null or undefined');
		}

		const O = Object(this);
		const len = O.length >>> 0;
		for (let i = len - 1; i >= 0; i--) {
			if (i in O && callback.call(thisArg, O[i], i, O)) {
				return i;
			}
		}
		return -1;
	};
}
